import { ContentWrapper } from "../../../../../shared/styled/TableStyles";
import { PieChartComponent } from "../../Content/PieChart";
import TopCustomersTable from "../../Content/TopCustomerTable";
import TopProductOrdersTable from "../../Content/TopProductOrdersTable";
import { TabWrapper } from "../Styled";
import { RevenueLineGraph } from "./RevenueLineGraph";

export const RevenueTab = () => {
    return (
        <TabWrapper>
            <RevenueLineGraph />

            <div
                style={{
                    display: "flex",
                    width: "100%",
                    gap: "30px",
                }}
            >
                <ContentWrapper>
                    <span
                        style={{
                            fontSize: "22px",
                            fontWeight: 600,
                            fontFamily: "Noto Sans",
                            marginBottom: "8px",
                        }}
                    >
                        Tổng quan trạng thái đơn hàng
                    </span>
                    <PieChartComponent />
                </ContentWrapper>

                <TopCustomersTable />
            </div>

            <TopProductOrdersTable />
        </TabWrapper>
    );
};
